import changeLocation from './change-location'

export function sessionExpired(redirectPath = '/login') {
  // When a session has expired we need to reload the page so that any PII
  // embedded in the HTML page is removed.
  changeLocation(`${redirectPath}?expired=true`)
}
